export  const CREATE_INFRA_ZONE = "infra_zone";
export const ZONE_LIST = 'zone_list';